import { render, staticRenderFns } from "./BNR.vue?vue&type=template&id=953a8262&scoped=true"
import script from "./BNR.vue?vue&type=script&lang=js"
export * from "./BNR.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953a8262",
  null
  
)

export default component.exports